

<template>
  <div style="background: #fff;padding: 30px;">
    <div style="margin-bottom: 20px;">
    咨询师姓名:   <el-input type="text" v-model="params.realName" clearable placeholder="输入咨询师姓名" style="width:300px;margin-left:20px; margin-right: 20px;"></el-input>

      <div class="Reviewstatus">审核状态：
        <el-select v-model="params.status" clearable placeholder="请选择">
          <el-option label="待审核" value="0"></el-option>
          <el-option label="审核通过" value="1"></el-option>
          <el-option label="审核不通过" value="2"></el-option>
          <el-option label="信息待完善" value="3"></el-option>
        </el-select>
      </div>

      <el-button type="primary" @click="seachclick">搜索</el-button>
      <el-button @click="react">重置</el-button>
    </div>
    <el-table
        :data="attestationDat"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        v-loading="loading"
        element-loading-text="拼命加载中···"
        style="width: 100%;margin-bottom: 20px;">
      <el-table-column
          label="序号"
          type="index"
          width="60px"
          :index="indexMethod"
          >
      </el-table-column>
      <el-table-column
          prop="RealName"
          label="咨询师">
      </el-table-column>
      <el-table-column
          prop="Bak2"
          label="工作校区">
      </el-table-column>
      <el-table-column
          label="擅长方向"
          prop="Expertise">
      </el-table-column>
      <el-table-column label="审核状态" prop="zcheckSate">
        <template v-slot="scope">
          <span v-if="!scope.row.ZCheckSate">信息待完善</span>
        <span v-else-if="scope.row.ZCheckSate==0 || scope.row.ZCheckSate=='0'">待审核</span>
        <span v-else-if="scope.row.ZCheckSate==1 || scope.row.ZCheckSate=='1'">审核通过</span>
        <span v-else-if="scope.row.ZCheckSate==2 || scope.row.ZCheckSate=='2'">审核不通过</span>
        </template>
      </el-table-column>
      <el-table-column
          label="创建时间"
          sortable
          prop="CreatedDate">
      </el-table-column>
      <el-table-column label="操作">
        <template v-slot="scope">
          <span style="color: #0d78e3;cursor: pointer" @click="Detailclick(scope.row)">查看</span>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="params.pageNo"
        :page-size="params.pageSize"
        layout="prev, pager, next, jumper"
        :hide-on-single-page="true"
        :total="params.totle">
    </el-pagination>

    <el-dialog
        title="咨询师认证申请"
        :visible.sync="ConsultantDetail"
        width="520px"
        >
      <div class="content">
        <el-form ref="form" label-width="140px" style="width:480px;">
          <el-form-item label="咨询师："> {{ ConsultantDetailData.RealName }} </el-form-item>
          
          <el-form-item label="个人照片：">
            <el-col :span="8">
              <el-image :src="ConsultantDetailData.ZHeadPhotoURL" :preview-src-list="[ConsultantDetailData.ZHeadPhotoURL]">
                <div slot="error" class="image-slot">暂未添加</div>
              </el-image></el-col>
          </el-form-item>
          <el-form-item label="咨询师视频号：">
            <el-col :span="16">
              <el-input v-model="ConsultantDetailData.VideoAccount"></el-input>
            </el-col>
          </el-form-item>
          
          <el-form-item label="工作校区："> 
            <el-col :span="16">
              <span v-if="!this.Global.pdroleid(1057) || this.Global.pdroleid(1066)">{{ ConsultantDetailData.Bak2 }}</span>
              <el-select v-model="ConsultantDetailData.Bak2" placeholder="请选择" v-else>
                <el-option
                  v-for="item in DictionaryList"
                  :key="item.dicKey"
                  :label="item.cDicValue"
                  :value="item.dicKey">
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>
          
          <el-form-item label="擅长方向："><el-col :span="16"><el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="ConsultantDetailData.Expertise" :disabled="this.Global.pdroleid(1057) || this.Global.pdroleid(1066)?false:true"></el-input></el-col></el-form-item>
          
          <el-form-item label="专业技能认证：">
            <el-col :span="7" :offset="1" v-for="item of ConsultantDetailData.certificates"><el-image :src="item" :preview-src-list="ConsultantDetailData.certificates">
              <div slot="error" class="image-slot">暂未添加</div>
            </el-image>
          </el-col>
          </el-form-item>

          <el-form-item label="专业技能认证说明：">
            {{ ConsultantDetailData.CertificateInstruction}}
          </el-form-item>

          <el-form-item label="无违法记录证明：">   
            <el-col :span="8">
              <el-image :src="ConsultantDetailData.CriminalCheck" :preview-src-list="[ConsultantDetailData.CriminalCheck]">
                <div slot="error" class="image-slot">暂未添加</div>
              </el-image></el-col>
          </el-form-item>

          <el-form-item label="创建时间："> {{ ConsultantDetailData.CreatedDate }} </el-form-item>

          <el-form-item label="个人简介：" style="line-height: 24px">
            <el-col :span="20">
              <el-input type="textarea" v-model="ConsultantDetailData.IndividualResume" v-if="this.Global.pdroleid(1057) || this.Global.pdroleid(1066)"></el-input>
              <span v-else></span>
            </el-col>
          </el-form-item>

          <el-form-item label="咨询师级别：">
            <el-row>
              <el-col :span="20">
                <el-select v-model="Consultantlevelval" placeholder="请选择" @change="ConsultantlevelChange" style="width: 100%;">
                  <el-option
                    v-for="item in Consultantlevel"
                    :key="item.dicKey"
                    :label="item.cDicValue"
                    :value="item.dicKey">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="聘用时间：" v-if="this.Global.pdroleid(1057) || this.Global.pdroleid(1066)"> 
            <el-col :span="20">
              <el-date-picker
              @change="dataTimeChange"
              style="width:100%;"
              v-model="EmploymentTime"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
            </el-col>
          </el-form-item>


          <el-form-item label="续聘说明：" style="line-height: 24px" v-if="this.Global.pdroleid(1057) || this.Global.pdroleid(1066)">
            <el-col :span="20">
              <el-input type="textarea" v-model="ConsultantDetailData.AppointmentInstruction"></el-input>
            </el-col>
          </el-form-item>

          <el-form-item label="上传附件材料：" v-if="this.Global.pdroleid(1057) || this.Global.pdroleid(1066)">
            
            <el-upload
              class="upload-demo"
              :action="actionUrl"
              :headers="{
                  Authorization:Authorization
                }"
              :on-remove="handleRemove"
              name="images"
              accept="image/jpeg,image/gif,image/png"
              multiple
              :limit="10"
              :on-exceed="handleExceed"
              :on-success="handsuccess"
              :before-upload="handupload"
              :on-preview="handpreview"
              :file-list="fileList">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <p style="color: #8b8b8b;font-size: 12px;">提示：最多可上传10张</p>
          </el-form-item>

          

        </el-form>
      </div>
      <div class="item" style="display: block">
        <label>审批状态：</label>
        <span v-if="!ConsultantDetailData.ZCheckSate">信息待完善</span>
        <span v-else-if="ConsultantDetailData.ZCheckSate==0 || ConsultantDetailData.ZCheckSate=='0'">待审核</span>
        <span v-else-if="ConsultantDetailData.ZCheckSate==1 || ConsultantDetailData.ZCheckSate=='1'">审核通过</span>
        <span v-else-if="ConsultantDetailData.ZCheckSate==2 || ConsultantDetailData.ZCheckSate=='2'">审核不通过</span>
      </div>
      <div class="item" v-if="ConsultantDetailData.ZCheckSate==0 || ConsultantDetailData.ZCheckSate==2" style="display: flex;line-height: 23px;">
        <label style="width: 70px"> 拒绝原因：</label>
        <el-input v-if="ConsultantDetailData.ZCheckSate==0" type="textarea" placeholder="仅需在拒绝时填写" v-model="ConsultantDetailData.zcheckLog" style="width: 370px"></el-input>
        <div v-else>{{ConsultantDetailData.ZCheckLog}}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ConsultantDetail = false">取 消</el-button>
        <el-button type="primary" v-if="ConsultantDetailData.ZCheckSate==0" :loading="refuseload" plain @click="authenticationClick(false,ConsultantDetailData.UserID)">拒 绝</el-button>
        <el-button type="primary" v-if="ConsultantDetailData.ZCheckSate==0" :loading="saveload" @click="editCertifiedClick(1,ConsultantDetailData.UserID)">同 意</el-button>
        <el-button type="primary" v-if="this.Global.pdroleid(1057) ||this.Global.pdroleid(1066)" :loading="saveload" @click="editCertifiedClick(0)">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 查看大图 -->
    <el-dialog :visible.sync="dialogimgVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>

  </div>
</template>

<script>
export default {
  name:'CertifiedConsultant',
  data(){
    return{
      dialogimgVisible:false,
      dialogImageUrl:'',
      attestationDat:[],
      loading:true,
      params:{
        realName:'',
        status:'',
        pageNo:1,
        pageSize:10,
        totle:0
      },


    //   详情弹窗
      actionUrl:process.env.VUE_APP_URL+'AppUser/UpdatePortraitAndCertificate',
      Authorization:sessionStorage.getItem('Authorization'),
      ConsultantDetail:false,
      ConsultantDetailData:'',
      refusalvalue:'',
      Consultantlevel:'',
      Consultantlevelval:'',
      dicKey:'',
      RoleID:sessionStorage.getItem('RoleID'),
      EmploymentTime:[],
      fileList:[],
      DictionaryList:[],
      refuseload:false,
      saveload:false,
    }
  },
  created() {
    this.list();
  },
  methods:{
    list(){
      var _this=this;
      this.$Http_Get("User/getCheckAuditList",this.params).then((res) => {
        if (res.Code == 0) {
          _this.loading=false;
          _this.attestationDat=res.Data.rows;
          _this.params.totle=res.Data.total;
        }
      });
    },
    indexMethod(index) {
        return index+1 + (this.params.pageSize*(this.params.pageNo-1));
      },
    Detailclick(e){
      this.ConsultantDetail = true;
      this.ConsultantDetailData = e;
      this.Consultantlevelval = e.positionName?e.positionName:'';
      this.getConsultantlevel();
      
      this.Global.pdroleid(1057) || this.Global.pdroleid(1066)?this.GetDictionary():'';
      if(this.ConsultantDetailData.AppointmentStart && this.ConsultantDetailData.AppointmentEnd){
        this.EmploymentTime=[];
        this.EmploymentTime.push(this.ConsultantDetailData.AppointmentStart);
        this.EmploymentTime.push(this.ConsultantDetailData.AppointmentEnd);
      }
      if(e.ConsultantAttachment){
        this.Capture(e);
      }
    },
    // 截取文件上传
    Capture(e){
      this.fileList=[];
      for(let item of e.ConsultantAttachment.split(',')){
        let itemindexOf=item.lastIndexOf("\\");
        let data={
          name:item.slice(itemindexOf+1),
          img:item
        }
        this.fileList.push(data);
      }
    },

    // 获取工作校区数据
    GetDictionary(){
      this.$Http_Post('User/GetDictionaryList',{DicTypCode:16}).then(res=>{
        if(res.Code==0){
          this.DictionaryList=res.Data
        }else{
          this.$message({
            type: 'error',
            message: res.Message,
          })
        }
      });
    },
    // 获取咨询师级别
    getConsultantlevel(){
      this.$Http_Get("User/getPositionList",{dicTypCode:38}).then((res) => {
        if (res.Code == 0) {
          this.Consultantlevel=res.Data;
          this.Consultantlevelval=this.Consultantlevelval?this.Consultantlevelval:res.Data[2].cDicValue;
          if(this.Consultantlevelval){
            for(let item of res.Data){
              if(item.cDicValue==this.Consultantlevelval){
                this.dicKey=item.dicKey;
              }
            }
          }else{
            this.dicKey=res.Data[0].dicKey;
          }
        }
      });
    },
    ConsultantlevelChange(e){
      this.dicKey=e;
    },

    seachclick(){
      this.params.pageNo=1;
      this.list();
    },
    // 
    react(){
      this.params=this.$options.data().params;
      this.list();
    },
    // 咨询师认证
    authenticationClick(e,userid){
      let state=e?1:2;
      this.refuseload=true;
      this.$Http_Post(`User/approvedAppState?userId=${userid}&state=${state}&reason=${this.ConsultantDetailData.zcheckLog}`).then((res) => {
        if (res.Code == 0) {
          this.$message({
            type: 'success',
            message: '提交成功',
          });
          this.ConsultantDetail=false;
          this.list();
          this.editConsultant();
        }else{
          this.$message({
            type: 'error',
            message: '提交失败',
          })
        }
        this.refuseload=false;
      });
    },
    handleCurrentChange(e){
      this.params.pageNo=e;
      this.list();
    },
    // 上传时钩子
    handupload(e){
      if(!/\.(jpg|jpeg|png|JPG|PNG|pdf|PDF)$/.test(e.name)){
        this.$message({
          type: 'warning',
          message: '请上传pdf或者jpg或者png格式的文件',
        });
        return false;
      }
    },
    // 文件上传成功
    handsuccess(e,fileList){
      fileList['img']=e.Data;
      this.fileList.push(fileList);
    },
    // 文件超出提示
    handleExceed(){
      this.$message({
            type: 'warning',
            message: '最多可上传10个文件',
          });
    },
    // 删除上传文件
    handleRemove(file, fileList){
      for(var i=0;i<this.fileList.length;i++){
        if(this.fileList[i].uid==file.uid){
          this.fileList.splice(i,1);
        }
      }
    },
    // 获取选择日期
    dataTimeChange(e){
      this.ConsultantDetailData.AppointmentStart=e[0];
      this.ConsultantDetailData.AppointmentEnd=e[1];
    },
    // 修改咨询师信息
    editCertifiedClick(e){
      let params={
        UserID:this.ConsultantDetailData.UserID, //用户ID
        WorkArea:this.ConsultantDetailData.Bak2, //工作校区
        Expertise:this.ConsultantDetailData.Expertise, //擅长方向
        IndividualResume:this.ConsultantDetailData.IndividualResume,//个人简介
        ConsultantAttachment:[],//续聘附件材料
        AppointmentStart:this.ConsultantDetailData.AppointmentStart,//聘用开始日期
        AppointmentEnd:this.ConsultantDetailData.AppointmentEnd,//聘用结束日期
        AppointmentInstruction:this.ConsultantDetailData.AppointmentInstruction,//聘用说明
        Position:this.dicKey,
        VideoAccount:this.ConsultantDetailData.VideoAccount
      };
      for(let item of this.fileList){
        params['ConsultantAttachment'].push(item.img)
      };
      this.saveload=true;
      this.$Http_Post('User/updateConsultantInformation',params).then(res=>{
        if(res.Code==0){
          if(e==1){
            this.authenticationClick(true,this.ConsultantDetailData.UserID);
          }else{
            this.$message({type: 'success',message:'修改成功'});
          }
          this.ConsultantDetail=false;
          this.list();
        }else{
          this.$message({
            type: 'error',
            message:res.Message,
          });
        }
        this.saveload=false;
      })
    },

    // 查看文件
    handpreview(file){
      if(file.name.indexOf('pdf')!=-1){
        window.open(file.img);
        return false;
      }
      this.dialogImageUrl=file.img;
      this.dialogimgVisible=true;
    }
  }
}
</script>

<style scoped>
.Reviewstatus{display: inline-block;margin-right: 30px;}
.content{background: #F5F7FA;padding: 20px 0;}
.el-form-item{margin:6px;}
img{width: 100%;display: block;}
.item{display: inline-flex;line-height: 40px;}
</style>